module.exports = __webpack_public_path__ + "static/media/solution20.4d98ba1a.png";